import { defineStore } from 'pinia'
import { store } from '../index'
import { useCookies } from '@/libs/cookie'
import storage from '@/libs/storage';
import * as http from '@/libs/http';

const prefix = 'pc_';
const cookie = useCookies();
export const useUserStore = defineStore('user',{
    state:()=>({
        token: storage.get(prefix + "token",null) || null,
        user: storage.get(prefix + "user",{
            avatar: "",
            username: ""
        }),
        cartCount: 0
    }),
    getters: {
        isLogin(state){
            return !!state.token;
        }
    },
    actions: {
        async getCartCount(){
            const { code, data } = await http.get("cart/count");
            this.cartCount = data;
            return data;
        },
        getToken(){
            return this.token;
        },
        async getUser() {
            if(this.token == null || this.token.length <= 0) return ;
            let params = {};
            const {code,data} = await http.get("user/center",params);
            if(!code) {
                this.user = null;
                this.token = null;
                storage.remove(prefix + "user");
                storage.remove(prefix + "token");
                return ;
            }

            this.user = data;
            storage.set(prefix + "user",data);
        },
        login(value){
            this.token = value;
            storage.set(prefix + "token",value);
        },
        logout(){
            this.token = null;
            this.user  = null;
            storage.remove(prefix + "user");
            storage.remove(prefix + "token");
        }
    }
});

export const useUserStoreWithOut = () => {
  return useUserStore(store)
}